// extracted by mini-css-extract-plugin
export var container = "_jr-0";
export var dotAnimation = "_jr-2";
export var dotsLoading = "_jr-1";